import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      common: {
        ...store.getState().i18n.translations.en.common,
        popup: {
          ...store.getState().i18n.translations.en.common.popup,
          manageCompanyPortfolio: {
            TITLE: "Manage Company's Portfolios",
            PORTFOLIO_NAME: 'Portfolio Name',
            REMOVE_FROM_ALL: 'Remove from all',
            ADD_TO_ALL: 'Add to all',
            ADD: 'Add',
            REMOVE: 'Remove',
            REMOVE_FROM_PORT:
              'Are you sure you want to remove this company from selected portfolio?',
            REMOVE_FROM_MULTIPLE_PORT:
              'Are you sure you want to remove this company from all portfolios?',
            ADD_TO_PORT:
              'Are you sure you want to add this company to selected portfolio?',
            ADD_TO_MULTIPLE_PORT:
              'Are you sure you want to add this company to all portfolios?',
          },
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      common: {
        ...store.getState().i18n.translations.vi.common,
        popup: {
          ...store.getState().i18n.translations.vi.common.popup,
          manageCompanyPortfolio: {
            TITLE: 'Quản Lý Danh Mục Chứa Công Ty',
            PORTFOLIO_NAME: 'Tên Danh Mục',
            REMOVE_FROM_ALL: 'Loại khỏi tất cả danh mục',
            ADD_TO_ALL: 'Thêm vào tất cả danh mục',
            ADD: 'Thêm',
            REMOVE: 'Xóa',
            REMOVE_FROM_PORT:
              'Bạn có chắc chắn muốn loại công ty này ra khỏi danh mục được chọn?',
            REMOVE_FROM_MULTIPLE_PORT:
              'Bạn có chắc chắn muốn loại công ty này ra khỏi tất cả các danh mục?',
            ADD_TO_PORT:
              'Bạn có chắc chắn muốn thêm công ty này vào danh mục được chọn?',
            ADD_TO_MULTIPLE_PORT:
              'Bạn có chắc chắn muốn thêm công ty này vào tất cả các danh mục?',
          },
        },
      },
    },
  }),
)
